/**
 * Created by sidchik on 16.10.14.
 */
/**
 * Created by sidchik on 16.10.14.
 */

//VK.init({apiId: 4589311, onlyWidgets: true});

function setSocialButtonVK($modal, postData)
{

}

function socialPostVK(postData)
{
  Share.vk(postData, function() {
    postData.success();
  });


  //VK.Api.call('wall.post', {
  //    message: postData.message,
  //    attachments: [postData.url]
  //}, function (r) {
  //    if (r.response) {
  //        postData.success(r.response.post_id);
  //    } else {
  //        postData.error();
  //    }
  //});
}